const e = Object.freeze({
  ANIMAL: {
    path: "animal.svg",
    tags: ["animal", "dog", "other"]
  },
  APARTMENT: {
    path: "apartment.svg",
    tags: ["apartment", "property"]
  },
  ARROW_INTERLOCKING: {
    path: "arrow-interlocking.svg",
    tags: ["arrow", "interlocking", "exchange", "change"]
  },
  BASEMENT: {
    path: "basement.svg",
    tags: ["basement", "property"]
  },
  BANK_DRAFT: {
    path: "bank-draft.svg",
    tags: ["bank", "draft"]
  },
  BELL_ACTIVE: {
    path: "bell-active.svg",
    tags: ["bell", "notification", "header icon", "members navigation"]
  },
  BELL_DEFAULT: {
    path: "bell-default.svg",
    tags: ["bell", "header icon", "members navigation"]
  },
  BELL_FILLED_YELLOW: {
    path: "bell-filled-yellow.svg",
    tags: ["bell", "notification", "yellow", "status"]
  },
  BELL_MOTION_GREY: {
    path: "bell-motion-grey.svg",
    tags: ["bell", "motion", "grey", "status"]
  },
  BOAT: {
    path: "boat.svg",
    tags: ["boat"]
  },
  BOAT_SIDEVIEW: {
    path: "boat-sideview.svg",
    tags: ["boat", "watercraft"]
  },
  BRIEFCASE: {
    path: "briefcase.svg",
    tags: ["briefcase"]
  },
  BUILDING_THUMBS_UP: {
    path: "building_thumbs_up.png",
    tags: ["building", "thumbs up"]
  },
  BUILDING_THUMBS_UP_SVG: {
    path: "building-thumbsup.svg",
    tags: ["building", "thumbs up"]
  },
  BUILDING_COMMERCIAL: {
    path: "building-commercial.svg",
    tags: ["building", "commercial"]
  },
  BUILDING_GENERIC: {
    path: "building-generic.svg",
    tags: ["building", "generic"]
  },
  BUILDING_INDUSTRIAL: {
    path: "building-industrial.svg",
    tags: ["building", "industrial"]
  },
  BUILDING_NATURE: {
    path: "building-nature.svg",
    tags: ["building", "nature"]
  },
  BUILDING_NATURE_EM: {
    path: "building-nature-emphasis.svg",
    tags: ["building", "nature", "emphasis"]
  },
  BUILDING_REFRESH: {
    path: "building-refresh.svg",
    tags: ["building", "refresh"]
  },
  BUSINESS: {
    path: "business.svg",
    tags: ["business", "category", "members navigation"]
  },
  CALENDAR: {
    path: "calendar.svg",
    tags: ["calendar"]
  },
  CALENDAR_AFTER_1981: {
    path: "calendar_after_1981.png",
    tags: ["after", "calendar", "1981"]
  },
  CALENDAR_AFTER_1981_SVG: {
    path: "calendar-1981-plus.svg",
    tags: ["after", "calendar", "1981"]
  },
  CALENDAR_BEFORE_1978: {
    path: "calendar_before_1978.png",
    tags: ["before", "calendar", "1978"]
  },
  CALENDAR_BEFORE_1978_SVG: {
    path: "calendar-1978-minus.svg",
    tags: ["before", "calendar", "1978"]
  },
  CALENDAR_BETWEEN_1979_1980: {
    path: "calendar_between_1979_1980.png",
    tags: ["between", "calendar", "1979", "1980"]
  },
  CALENDAR_BETWEEN_1979_1980_SVG: {
    path: "calendar-1979-1980.svg",
    tags: ["between", "calendar", "1979", "1980"]
  },
  CALENDAR_CHECKMARK_ONE: {
    path: "calendar-checkmark-1.svg",
    tags: ["calendar", "checkmark"]
  },
  CALENDAR_CHECKMARK_TWO: {
    path: "calendar-checkmark-2.svg",
    tags: ["calendar", "checkmark"]
  },
  CALENDAR_CLOCK: {
    path: "calendar-clock.svg",
    tags: ["calendar", "clock"]
  },
  CALENDAR_DATE_DOLLAR: {
    path: "calendar-date-dollar.svg",
    tags: ["calendar", "dollar"]
  },
  CALENDAR_DATE_SELECTED: {
    path: "calendar-date-selected.svg",
    tags: ["calendar", "date", "selected"]
  },
  CALENDAR_DATE_STOP: {
    path: "calendar-date-stop.svg",
    tags: ["calendar", "date", "stop"]
  },
  CALENDAR_DOLLAR: {
    path: "calendar_dollar.png",
    tags: ["calendar", "dollar"]
  },
  CALENDAR_DOLLAR_SVG: {
    path: "calendar-dollar.svg",
    tags: ["calendar", "dollar"]
  },
  CALENDAR_ELLIPSIS: {
    path: "calendar-ellipsis.svg",
    tags: ["calendar", "ellipsis"]
  },
  CALENDAR_EXCLAMATION: {
    path: "calendar-exclamation.svg",
    tags: ["calendar", "exclamation"]
  },
  CALENDAR_FIFTEENTH: {
    path: "calendar_fifteenth.png",
    tags: ["calendar", "fifteenth", "15th"]
  },
  CALENDAR_FIFTEENTH_SVG: {
    path: "calendar-fifteenth.svg",
    tags: ["calendar", "fifteenth", "15th"]
  },
  CALENDAR_FIRST: {
    path: "calendar_first.png",
    tags: ["calendar", "first", "1st"]
  },
  CALENDAR_FIRST_SVG: {
    path: "calendar-first.svg",
    tags: ["calendar", "first", "1st"]
  },
  CALENDAR_FOURTEEN_DAYS: {
    path: "calendar-14days.svg",
    tags: ["calendar", "fourteen", "days", "14"]
  },
  CALENDAR_HASHTAG: {
    path: "calendar-hashtag.svg",
    tags: ["calendar", "hashtag"]
  },
  CALENDAR_ICON: {
    path: "calendar_icon.svg",
    tags: ["calendar", "icon"]
  },
  CALENDAR_MONTHLY: {
    path: "calendar_monthly.png",
    tags: ["calendar", "monthly"]
  },
  CALENDAR_MONTHLY_SVG: {
    path: "calendar-monthly.svg",
    tags: ["calendar", "monthly"]
  },
  CALENDAR_MONTH: {
    path: "calendar_month.svg",
    tags: ["calendar", "month"]
  },
  CALENDAR_NUMBER: {
    path: "calendar_number.png",
    tags: ["calendar", "number"]
  },
  CALENDAR_NUMBER_ONE: {
    path: "calendar-number1.svg",
    tags: ["calendar", "number", "1", "one"]
  },
  CALENDAR_NUMBER_TWO: {
    path: "calendar-number2.svg",
    tags: ["calendar", "number", "2", "two"]
  },
  CALENDAR_NUMBER_THREE: {
    path: "calendar-number3.svg",
    tags: ["calendar", "number", "3", "three"]
  },
  CALENDAR_NUMBER_FIVE: {
    path: "calendar-number5.svg",
    tags: ["calendar", "number", "5", "five"]
  },
  CALENDAR_NUMBER_SIX: {
    path: "calendar_number6.svg",
    tags: ["calendar", "number", "6", "six"]
  },
  CALENDAR_ONE_MONTH: {
    path: "calendar-1month.svg",
    tags: ["calendar", "one", "month", "1"]
  },
  CALENDAR_ONE_WEEK: {
    path: "calendar_one_week.png",
    tags: ["calendar", "one", "week", "1"]
  },
  CALENDAR_ONE_WEEK_SVG: {
    path: "calendar-1week.svg",
    tags: ["calendar", "one", "week", "1"]
  },
  CALENDAR_OTHER: {
    path: "calendar_other.png",
    tags: ["calendar", "other"]
  },
  CALENDAR_PERSON_ONE: {
    path: "calendar-person-1.svg",
    tags: ["calendar", "person"]
  },
  CALENDAR_PERSON_TWO: {
    path: "calendar-person-2.svg",
    tags: ["calendar", "person"]
  },
  CALENDAR_PIECHART: {
    path: "calendar-piechart.svg",
    tags: ["calendar", "piechart"]
  },
  CALENDAR_QUESTIONMARK: {
    path: "calendar-questionmark.svg",
    tags: ["calendar", "questionmark"]
  },
  CALENDAR_REFRESH_ONE: {
    path: "calendar-refresh-1.svg",
    tags: ["calendar", "refresh"]
  },
  CALENDAR_REFRESH_TWO: {
    path: "calendar-refresh-2.svg",
    tags: ["calendar", "refresh"]
  },
  CALENDAR_SEVEN_DAYS: {
    path: "calendar-7days.svg",
    tags: ["calendar", "seven", "days", "7"]
  },
  CALENDAR_SIX_MONTHS: {
    path: "calendar-6months.svg",
    tags: ["calendar", "six", "months", "6"]
  },
  CALENDAR_SPECIFY: {
    path: "calendar-specify.png",
    tags: ["calendar", "specify"]
  },
  CALENDAR_STOP: {
    path: "calendar_stop.png",
    tags: ["calendar", "stop"]
  },
  CALENDAR_THREE_MONTHS: {
    path: "calendar-3months.svg",
    tags: ["calendar", "three", "months", "3"]
  },
  CALENDAR_THIRTY_DAYS: {
    path: "calendar-30days.svg",
    tags: ["calendar", "thirty", "days", "30"]
  },
  CALENDAR_TODAY: {
    path: "calendar-today.svg",
    tags: ["calendar", "today"]
  },
  CALENDAR_TWO_WEEKS: {
    path: "calendar_two_weeks.png",
    tags: ["calendar", "two", "weeks", "2"]
  },
  CALENDAR_TWO_WEEKS_SVG: {
    path: "calendar-2weeks.svg",
    tags: ["calendar", "two", "weeks", "2"]
  },
  CALENDAR_UNSURE: {
    path: "calendar-unsure.png",
    tags: ["calendar", "unsure"]
  },
  CALENDAR_YEAR: {
    path: "calendar_year.png",
    tags: ["calendar", "year"]
  },
  CALENDAR_YEARLY: {
    path: "calendar_yearly.png",
    tags: ["calendar", "yearly", "annually"]
  },
  CALENDAR_YEARLY_SVG: {
    path: "calendar-yearly.svg",
    tags: ["calendar", "yearly", "annually"]
  },
  CAN_AB: {
    path: "ab-province.svg",
    tags: ["canada", "alberta", "ab", "province"]
  },
  CAN_BC: {
    path: "bc-province.svg",
    tags: ["canada", "british columbia", "bc", "province"]
  },
  CAN_MB: {
    path: "mb-province.svg",
    tags: ["canada", "manitoba", "mb", "province"]
  },
  CAN_NB: {
    path: "nb-province.svg",
    tags: ["canada", "new brunswick", "nb", "province"]
  },
  CAN_NL: {
    path: "nl-province.svg",
    tags: ["canada", "newfoundland", "labrador", "nl", "province"]
  },
  CAN_NS: {
    path: "ns-province.svg",
    tags: ["canada", "nova scotia", "ns", "province"]
  },
  CAN_NT: {
    path: "nt-province.svg",
    tags: ["canada", "northwest territories", "nt", "province", "territories"]
  },
  CAN_NU: {
    path: "nu-province.svg",
    tags: ["canada", "nunavut", "nu", "province", "territories"]
  },
  CAN_ON: {
    path: "on-province.svg",
    tags: ["canada", "ontario", "on", "province"]
  },
  CAN_PE: {
    path: "pe-province.svg",
    tags: ["canada", "prince edward island", "pe", "province"]
  },
  CAN_SK: {
    path: "sk-province.svg",
    tags: ["canada", "saskatchewan", "sk", "province"]
  },
  CAN_YT: {
    path: "yt-province.svg",
    tags: ["canada", "yukon", "yt", "province", "territories"]
  },
  CAR: {
    path: "car-blue.svg",
    tags: ["car", "vehicle"]
  },
  CAR_RED: {
    path: "car-red.svg",
    tags: ["car", "vehicle", "motor-vehicle", "automobile"]
  },
  CASH: {
    path: "cash.svg",
    tags: ["cash", "money", "dollar"]
  },
  CHECK: {
    path: "check.svg",
    tags: ["check", "money", "dollar"]
  },
  CHECKMARK: {
    path: "checkmark.png",
    tags: ["checkmark", "yes"]
  },
  CHECKMARK_EDIT: {
    path: "checkmark-edit.svg",
    tags: ["checkmark", "edit"]
  },
  CHECKMARK_GREEN: {
    path: "checkmark-green.svg",
    tags: ["checkmark", "green"]
  },
  CHECKMARK_YELLOW: {
    path: "checkmark-yellow.svg",
    tags: ["checkmark", "green"]
  },
  CHECKMARK_CIRCLE: {
    path: "check-circle-filled.svg",
    tags: ["check", "checkmark", "circle", "success"]
  },
  CHEQUE: {
    path: "cheque.svg",
    tags: ["check", "money", "dollar", "cheque"]
  },
  CHEQUE_DOLLAR: {
    path: "cheque-dollar.svg",
    tags: ["check", "money", "dollar", "cheque"]
  },
  CHEQUE_RIBBON: {
    path: "cheque-ribbon.svg",
    tags: ["check", "money", "dollar", "cheque", "ribbon"]
  },
  CHEVRON_DOWN: {
    path: "expand_more_black_24dp.svg",
    tags: ["chevron", "down", "more", "open", "toggle", "expand"]
  },
  CHILDREN_GROUP_OF_TWO: {
    path: "children-groupof2.svg",
    tags: ["child", "children", "group"]
  },
  CIRCLE_EXCLAMATION_FILLED_RED: {
    path: "circle-exclamation-filled-red.svg",
    tags: ["circle", "exclamation", "status"]
  },
  CIRCLE_MINUS: {
    path: "circle-minus.svg",
    tags: ["minus", "toggle", "subtract"]
  },
  CIRCLE_PLUS: {
    path: "circle-plus.svg",
    tags: ["plus", "toggle", "add"]
  },
  CIRCLE_SPEECH_BUBBLE: {
    path: "circle-speech-bubble.svg",
    tags: ["speech", "bubble"]
  },
  CIRCLE_STAR_FILLED_BLUE: {
    path: "circle-star-filled-blue.svg",
    tags: ["circle", "star", "status", "blue"]
  },
  CIRCLE_WITH_USER: {
    path: "circle-with-user.svg",
    tags: ["user", "document"]
  },
  CIRCLE_X: {
    path: "x.png",
    tags: ["x", "no", "cancel", "delete"]
  },
  CLIPBOARD_LIST_ONE: {
    path: "clipboard-list-1.svg",
    tags: ["clipboard", "list"]
  },
  CLIPBOARD_LIST_TWO: {
    path: "clipboard-list-2.svg",
    tags: ["clipboard", "list"]
  },
  CLIPBOARD_NUMBER_ONE: {
    path: "clipboard-number1.svg",
    tags: ["clipboard", "number", "one", "1"]
  },
  CLIPBOARD_NUMBER_TWO: {
    path: "clipboard-number2.svg",
    tags: ["clipboard", "number", "two", "2"]
  },
  CLIPBOARD_NUMBER_THREE: {
    path: "clipboard-number3.svg",
    tags: ["clipboard", "number", "three", "3"]
  },
  CLIPBOARD_NUMBER_FOUR: {
    path: "clipboard-number4.svg",
    tags: ["clipboard", "number", "four", "4"]
  },
  CLIPBOARD_NUMBER_FIVE: {
    path: "clipboard-number5.svg",
    tags: ["clipboard", "number", "five", "5"]
  },
  CLIPBOARD_NUMBER_SIX: {
    path: "clipboard-number6.svg",
    tags: ["clipboard", "number", "six", "6"]
  },
  CLIPBOARD_NUMBER_SEVEN: {
    path: "clipboard-number7.svg",
    tags: ["clipboard", "number", "seven", "7"]
  },
  CLIPBOARD_NUMBER_EIGHT: {
    path: "clipboard-number8.svg",
    tags: ["clipboard", "number", "eight", "8"]
  },
  CLIPBOARD_NUMBER_NINE: {
    path: "clipboard-number9.svg",
    tags: ["clipboard", "number", "nine", "9"]
  },
  CLIPBOARD_NUMBER_TEN: {
    path: "clipboard-number10.svg",
    tags: ["clipboard", "number", "ten", "10"]
  },
  CLIPBOARD_NUMBER_ELEVEN: {
    path: "clipboard-number11.svg",
    tags: ["clipboard", "number", "eleven", "11"]
  },
  CLIPBOARD_NUMBER_TWELVE: {
    path: "clipboard-number12.svg",
    tags: ["clipboard", "number", "twelve", "12"]
  },
  CLIPBOARD_NUMBER_THIRTEEN: {
    path: "clipboard-number13.svg",
    tags: ["clipboard", "number", "thirteen", "13"]
  },
  CLIPBOARD_NUMBER_FOURTEEN: {
    path: "clipboard-number14.svg",
    tags: ["clipboard", "number", "fourteen", "14"]
  },
  CLIPBOARD_NUMBER_FIFTEEN: {
    path: "clipboard-number15.svg",
    tags: ["clipboard", "number", "fifteen", "15"]
  },
  CLIPBOARD_NUMBER_SIXTEEN: {
    path: "clipboard-number16.svg",
    tags: ["clipboard", "number", "one", "16"]
  },
  CLIPBOARD_NUMBER_SEVENTEEN: {
    path: "clipboard-number17.svg",
    tags: ["clipboard", "number", "seventeen", "17"]
  },
  CLIPBOARD_NUMBER_EIGHTEEN: {
    path: "clipboard-number18.svg",
    tags: ["clipboard", "number", "one", "18"]
  },
  CLIPBOARD_NUMBER_NINETEEN: {
    path: "clipboard-number19.svg",
    tags: ["clipboard", "number", "nineteen", "19"]
  },
  CLIPBOARD_NUMBER_TWENTY: {
    path: "clipboard-number20.svg",
    tags: ["clipboard", "number", "twenty", "20"]
  },
  CLIPBOARD_QUESTIONMARK: {
    path: "clipboard-questionmark.svg",
    tags: ["clipboard", "questionmark"]
  },
  CLOCK: {
    path: "clock.png",
    tags: ["clock", "time"]
  },
  CLOCK_HALF: {
    path: "clock-half.svg",
    tags: ["clock", "half"]
  },
  CLOCK_OUTLINE: {
    path: "clock-white-outline.svg",
    tags: ["clock", "time", "outline"]
  },
  CLOCK_SVG: {
    path: "clock.svg",
    tags: ["clock", "time"]
  },
  COMPUTER_CHECKMARK_CIRCLE: {
    path: "computer-checkmark-circle.svg",
    tags: ["computer", "checkmark", "circle"]
  },
  COMPUTER_CURSOR: {
    path: "computer-cursor.svg",
    tags: ["computer", "cursor"]
  },
  COMPUTER_MONITOR_CLICK: {
    path: "computer-monitor-click.svg",
    tags: ["computer", "monitor", "click"]
  },
  COMPUTER_OUTLINE: {
    path: "computer-outline.svg",
    tags: ["computer", "outline"]
  },
  COMPUTER_OUTLINE_WHITE: {
    path: "computer-white-outline.svg",
    tags: ["computer", "outline"]
  },
  CONDO: {
    path: "condo.svg",
    tags: ["condo", "property"]
  },
  CORPORATE_BUILDINGS: {
    path: "corporate_buildings.png",
    tags: ["corporate", "buildings"]
  },
  COUCH: {
    path: "couch.svg",
    tags: ["couch", "furniture"]
  },
  COUCH_GREEN: {
    path: "couch-green.svg",
    tags: ["couch", "sofa", "other", "property"]
  },
  CREDIT_CARD: {
    path: "creditcard.svg",
    tags: ["creditcard", "credit", "card"]
  },
  CREDIT_CARD_VISA: {
    path: "payment-card-visa.svg",
    tags: ["creditcard", "credit", "card", "payment", "visa"]
  },
  CREDIT_CARD_MASTERCARD: {
    path: "payment-card-mastercard.svg",
    tags: ["creditcard", "credit", "card", "payment", "mastercard"]
  },
  CREDIT_CARD_AMEX: {
    path: "payment-card-american-express.svg",
    tags: [
      "creditcard",
      "credit",
      "card",
      "payment",
      "amex",
      "american express"
    ]
  },
  CREDIT_CARD_MAESTRO: {
    path: "payment-card-maestro.svg",
    tags: ["creditcard", "credit", "card", "payment", "maestro"]
  },
  CREDIT_CARD_DISCOVER: {
    path: "payment-card-discover.svg",
    tags: ["creditcard", "credit", "card", "payment", "discover"]
  },
  DASH: {
    path: "dash.png",
    tags: ["dash"]
  },
  DATE_UNSURE: {
    path: "unsure-date.png",
    tags: ["date", "unsure"]
  },
  DATE_UNSURE_SVG: {
    path: "unsure-date.svg",
    tags: ["date", "unsure"]
  },
  DELETE_GREY: {
    path: "delete-grey.svg",
    tags: ["delete", "grey", "trashcan"]
  },
  DIVIDER_GREEN: {
    path: "green-divider.svg",
    tags: ["green", "divider"]
  },
  DOCUMENT_ARROW: {
    path: "document-arrow.svg",
    tags: ["document", "arrow"]
  },
  DOCUMENT_BLUE: {
    path: "document-blue.svg",
    tags: ["document", "blue", "muq"]
  },
  DOCUMENT_CHECKMARK: {
    path: "document_checkmark.png",
    tags: ["document", "checkmark"]
  },
  DOCUMENT_CHECKMARK_WHITE: {
    path: "document_checkmark_white.png",
    tags: ["document", "checkmark"]
  },
  DOCUMENT_CHECKMARK_BLUE: {
    path: "document_checkmark_blue.svg",
    tags: ["document", "checkmark"]
  },
  DOCUMENT_CHECKMARK_YELLOW: {
    path: "document_checkmark_yellow.svg",
    tags: ["document", "checkmark"]
  },
  DOCUMENT_EDIT: {
    path: "document-edit.svg",
    tags: ["document", "edit"]
  },
  DOCUMENT_FOLDER: {
    path: "document_folder.png",
    tags: ["document", "folder"]
  },
  DOCUMENT_FOLDER_SVG: {
    path: "document-folder.svg",
    tags: ["document", "folder"]
  },
  DOCUMENT_HTML: {
    path: "document-html.svg",
    tags: ["document", "html", "filetype"]
  },
  DOCUMENT_LIST_EDIT: {
    path: "document-list-edit.svg",
    tags: ["document", "list", "edit"]
  },
  DOCUMENT_LOCK_SIGNATURE: {
    path: "document-lock-signature.svg",
    tags: ["document", "lock", "signature"]
  },
  DOCUMENT_NO_CASH_REFRESH: {
    path: "document_no_cash_refresh.png",
    tags: ["document", "no cash", "refresh"]
  },
  DOCUMENT_NO_CASH_REFRESH_SVG: {
    path: "document-bag-blocked-refresh.svg",
    tags: ["document", "no cash", "refresh"]
  },
  DOCUMENT_MISC: {
    path: "document-misc.svg",
    tags: ["misc", "document", "category", "members navigation"]
  },
  DOCUMENT_OUTLINE: {
    path: "document-outline.svg",
    tags: ["document", "outline"]
  },
  DOCUMENT_OUTLINE_WHITE: {
    path: "document-white-outline.svg",
    tags: ["document", "outline"]
  },
  DOCUMENT_OUTLINE_GREEN: {
    path: "document-green-outline.svg",
    tags: ["document", "outline"]
  },
  DOCUMENT_PAPERCLIP: {
    path: "document-paperclip.svg",
    tags: ["document", "paperclip"]
  },
  DOCUMENT_PAPERCLIP_CHECKED: {
    path: "document-paperclip-checked.svg",
    tags: ["document", "paperclip", "paywall", "checked", "documents"]
  },
  DOCUMENT_PAPERCLIP_EDIT: {
    path: "document-paperclip-edit.svg",
    tags: ["document", "paperclip"]
  },
  DOCUMENT_PDF: {
    path: "document-pdf.svg",
    tags: ["document", "pdf", "filetype"]
  },
  DOCUMENT_PERSON: {
    path: "document_person.png",
    tags: ["document", "person"]
  },
  DOCUMENT_PERSON_BLOCKED: {
    path: "document-person-blocked.svg",
    tags: ["document", "person", "blocked"]
  },
  DOCUMENT_PERSON_BLUE: {
    path: "document-person-blue.svg",
    tags: ["document", "person"]
  },
  DOCUMENT_PERSON_BLUE_TWO: {
    path: "document-person-blue-2.svg",
    tags: ["document", "person"]
  },
  DOCUMENT_PERSON_GREEN: {
    path: "document-person-green.svg",
    tags: ["document", "person"]
  },
  DOCUMENT_PLUS: {
    path: "document-plus.svg",
    tags: ["document", "new", "create"]
  },
  DOCUMENT_PROTECTION: {
    path: "document_protection.png",
    tags: ["docment", "protection"]
  },
  DOCUMENT_REFRESH: {
    path: "document_refresh.png",
    tags: ["document", "refresh"]
  },
  DOCUMENT_REFRESH_SVG: {
    path: "document-refresh.svg",
    tags: ["document", "refresh"]
  },
  DOCUMENT_RIBBON: {
    path: "document-ribbon.svg",
    tags: ["document", "ribbon"]
  },
  DOCUMENT_SEAL: {
    path: "document_seal.png",
    tags: ["seal", "document"]
  },
  DOCUMENT_SPEECH_BUBBLE: {
    path: "document_speech_bubble.png",
    tags: ["document", "speech bubble"]
  },
  DOCUMENT_SPEECH_BUBBLE_CIRCLE: {
    path: "document-speech-bubble-circle.svg",
    tags: ["document", "speech bubble", "circle"]
  },
  DOCUMENT_SIGNING: {
    path: "document-signing.svg",
    tags: ["signing", "document", "sign"]
  },
  DOCUMENT_WRITE: {
    path: "document_write.png",
    tags: ["document", "write"]
  },
  DOG_BROWN: {
    path: "dog-brown.svg",
    tags: ["animal", "dog", "pet"]
  },
  DOLLAR_BILLS_COINS: {
    path: "dollar-bills-coins.svg",
    tags: ["dollar", "bills", "coins"]
  },
  DOLLAR_BILLS_NO: {
    path: "dollar-bills-no.svg",
    tags: ["dollar", "bills", "no"]
  },
  DOLLAR_BILLS_PET: {
    path: "dollar-bills-petbowl.svg",
    tags: ["dollar", "bills", "pet"]
  },
  DOLLAR_BLOCKED: {
    path: "dollar-blocked.svg",
    tags: ["dollar", "blocked"]
  },
  DOLLAR_BLOCKED_CLOCK: {
    path: "dollar-blocked-clock-emphasis.svg",
    tags: ["dollar", "blocked", "clocked"]
  },
  DOLLAR_BLUE: {
    path: "dollar-blue.svg",
    tags: ["blue", "dollar"]
  },
  DOLLAR_EDIT: {
    path: "dollar-edit.svg",
    tags: ["edit", "dollar"]
  },
  DOLLAR_EXCLAMATION: {
    path: "dollar-exclamation.svg",
    tags: ["exclamation", "dollar"]
  },
  DOLLAR_GEAR: {
    path: "dollar-gear.svg",
    tags: ["gear", "dollar"]
  },
  DOLLAR_GEAR_EDIT: {
    path: "dollar-gear-edit.svg",
    tags: ["gear", "dollar", "edit"]
  },
  DOLLAR_GEAR_PIECHART: {
    path: "dollar-gear-piechart.svg",
    tags: ["gear", "dollar", "piechart"]
  },
  DOLLAR_GREEN: {
    path: "dollar_green.png",
    tags: ["green", "dollar"]
  },
  DOLLAR_GREEN_SVG: {
    path: "dollar-green.svg",
    tags: ["green", "dollar"]
  },
  DOLLAR_INFINITY: {
    path: "dollar-infinity.svg",
    tags: ["infinity", "dollar"]
  },
  DOLLAR_SLATE: {
    path: "dollar_slate.png",
    tags: ["dollar"]
  },
  DOLLAR_TWO_TIMES: {
    path: "dollar-2x.png",
    tags: ["dollar", "multiply", "two", "times"]
  },
  DOLLAR_WARNING: {
    path: "dollar_warning.png",
    tags: ["dollar", "warning"]
  },
  DOLLAR_X: {
    path: "dollar-x.svg",
    tags: ["x", "dollar"]
  },
  DOWNLOAD_GREY: {
    path: "download-grey.svg",
    tags: ["download", "grey"]
  },
  DUPLEX: {
    path: "duplex.svg",
    tags: ["duplex", "property"]
  },
  DUPLICATE_GREY: {
    path: "duplicate-grey.svg",
    tags: ["duplicate", "grey"]
  },
  EDIT: {
    path: "edit.svg",
    tags: ["edit"]
  },
  ELECTRONIC_FUNDS: {
    path: "electronic-funds.svg",
    tags: ["electronic funds", "money", "dollar"]
  },
  ELLIPSIS_CIRCLE: {
    path: "ellipsis-circle.svg",
    tags: ["ellipsis", "circle", "more"]
  },
  ELIPSIS_GREY: {
    path: "elipses-grey.svg",
    tags: ["elipses", "circle", "more", "grey"]
  },
  ESTATE: {
    path: "estate.svg",
    tags: ["estate", "category", "members navigation"]
  },
  ERROR: {
    path: "error-octagon-filled.svg",
    tags: ["error", "error icon", "octagon"]
  },
  EXCLAMATION: {
    path: "circle-exclamation-solid.svg",
    tags: ["exclamation", "point", "error", "warning", "circle"]
  },
  EYE_FILLED_YELLOW: {
    path: "eye-filled-yellow.svg",
    tags: ["eye", "yellow", "viewed"]
  },
  FAMILY: {
    path: "family.svg",
    tags: ["family", "category", "members navigation"]
  },
  FOLDER: {
    path: "folder.svg",
    tags: ["folder", "documents", "members navigation"]
  },
  FOLDER_RIGHT_ARROW_GREY: {
    path: "folder-right-arrow-grey.svg",
    tags: ["folder", "documents", "right", "arrow", "grey"]
  },
  GAVEL: {
    path: "gavel.png",
    tags: ["gavel"]
  },
  GAVEL_SVG: {
    path: "gavel.svg",
    tags: ["gavel"]
  },
  GAVEL_WHITE: {
    path: "gavel_white.png",
    tags: ["gavel"]
  },
  GEAR_ACTIVE: {
    path: "gear-active.svg",
    tags: ["gear", "header icon", "members navigation"]
  },
  GEAR_DEFAULT: {
    path: "gear-default.svg",
    tags: ["gear", "header icon", "members navigation"]
  },
  GRADUATION_CAP_DOLLAR: {
    path: "graduationcap-dollar.svg",
    tags: ["graduation", "dollar", "cap"]
  },
  GUARANTEE_LEGAL: {
    path: "guarantee-legal.svg",
    tags: ["guarantee", "legal"]
  },
  GUARANTEE_QUALITY: {
    path: "guarantee-quality.svg",
    tags: ["guarantee", "quality"]
  },
  HANDSHAKE: {
    path: "handshake.png",
    tags: ["handshake"]
  },
  HANDSHAKE_SVG: {
    path: "handshake.svg",
    tags: ["handshake"]
  },
  HEART_SHIELD_OUTLINE: {
    path: "heart-shield-outline.svg",
    tags: ["shield", "heart"]
  },
  HISTORY_GREY: {
    path: "history-grey.svg",
    tags: ["history", "clock", "grey"]
  },
  HOME: {
    path: "home.svg",
    tags: ["home", "members navigation"]
  },
  HOURGLASS_HALF_FILLED_YELLOW: {
    path: "hourglass-half-filled-yellow.svg",
    tags: ["hourglass", "time", "yellow"]
  },
  HOUSE: {
    path: "house.svg",
    tags: ["house", "property"]
  },
  HOUSE_DOLLAR: {
    path: "house-dollar.svg",
    tags: ["house", "dollar"]
  },
  HOUSE_EM: {
    path: "house-emphasis.svg",
    tags: ["house", "emphasis"]
  },
  HOUSE_MAGNIFYING_2: {
    path: "house_magnifying_2.png",
    tags: ["2", "house", "magnifying", "glass"]
  },
  HOUSE_MAGNIFYING_2_SVG: {
    path: "house-magnifying-two.svg",
    tags: ["2", "house", "magnifying", "glass"]
  },
  HOUSE_MAGNIFYING_3: {
    path: "house_magnifying_3.png",
    tags: ["3", "house", "magnifying", "glass"]
  },
  HOUSE_MAGNIFYING_3_SVG: {
    path: "house-magnifying-3.png",
    tags: ["3", "house", "magnifying", "glass"]
  },
  HOUSE_MAGNIFYING_PERCENT: {
    path: "house_magnifying_percent.png",
    tags: ["house", "magnifying", "percent", "glass"]
  },
  HOUSE_MAGNIFYING_PERCENT_SVG: {
    path: "house-magnifying-percent.svg",
    tags: ["house", "magnifying", "percent", "glass"]
  },
  IGLOO: {
    path: "igloo.svg",
    tags: ["igloo", "property"]
  },
  INFO_GREY: {
    path: "info-grey.svg",
    tags: ["info", "grey"]
  },
  INFORMATION: {
    path: "info-circle-filled.svg",
    tags: ["information", "information icon"]
  },
  JUSTICE_BALANCE: {
    path: "justice-balance.svg",
    tags: ["justice", "balance"]
  },
  KEYS: {
    path: "keys.svg",
    tags: ["keys"]
  },
  LEASE: {
    path: "lease.svg",
    tags: ["lease", "category", "members navigation"]
  },
  LEFT_ARROWS: {
    path: "left-arrows.svg",
    tags: ["arrows", "left", "members navigation"]
  },
  LEFT_ARROWS_IN_CIRCLE: {
    path: "left-arrows-in-circle.svg",
    tags: ["arrows", "left", "arrows in circle", "members navigation"]
  },
  LIGHTBULB: {
    path: "lightbulb.png",
    tags: ["lightbulb"]
  },
  LIGHTBULB_SVG: {
    path: "lightbulb-emphasis.svg",
    tags: ["lightbulb"]
  },
  LIGHTBULB_BLACK: {
    path: "lightbulb-black.svg",
    tags: ["bulb", "resources", "members navigation"]
  },
  LIGHTBULB_GEAR: {
    path: "lightbulb_gear.png",
    tags: ["lightbulb gear", "lightbulb", "gear"]
  },
  LIGHTBULB_GEAR_SVG: {
    path: "lightbulb-gear.svg",
    tags: ["lightbulb gear", "lightbulb", "gear"]
  },
  LIGHTBULB_GEAR_EM: {
    path: "lightbulb-gear-emphasis.svg",
    tags: ["lightbulb gear", "lightbulb", "gear"]
  },
  LINK: {
    path: "link.svg",
    tags: ["link"]
  },
  LOGO_CNET: {
    path: "logo-cnet.svg",
    tags: ["logo", "cnet"]
  },
  LOGO_FORBES: {
    path: "logo-forbes.svg",
    tags: ["logo", "forbes"]
  },
  LOGO_MONEY: {
    path: "logo-money.svg",
    tags: ["logo", "money"]
  },
  LOGO_MSN: {
    path: "logo-msn.svg",
    tags: ["logo", "msn"]
  },
  LOGO_PC_MAGAZINE: {
    path: "logo-pc-magazine.svg",
    tags: ["logo", "pc", "magazine"]
  },
  LOGO_TIME: {
    path: "logo-time.svg",
    tags: ["logo", "time"]
  },
  LOGO_USA_TODAY: {
    path: "logo-usa-today.svg",
    tags: ["logo", "usa", "today"]
  },
  LOGO_WSJ: {
    path: "logo-wsj.svg",
    tags: ["logo", "wsj", "wall", "street", "journal"]
  },
  MAXIMUM: {
    path: "maximum.png",
    tags: ["maximum"]
  },
  MAXIMUM_SVG: {
    path: "meter-maximum.svg",
    tags: ["maximum"]
  },
  METER_FULL: {
    path: "meter-full-yellow-medical.svg",
    tags: ["meter", "full"]
  },
  METER_HALF: {
    path: "meter-half-blue-medical.svg",
    tags: ["meter", "half"]
  },
  MINIMUM: {
    path: "minimum.png",
    tags: ["minimum"]
  },
  MINIMUM_SVG: {
    path: "meter-minimum.svg",
    tags: ["minimum"]
  },
  MINIMUM_MORE: {
    path: "minimum_more.png",
    tags: ["more", "minimum"]
  },
  MINIMUM_MORE_SVG: {
    path: "meter-above-minimum.svg",
    tags: ["more", "minimum"]
  },
  MINUS: {
    path: "minus.svg",
    tags: ["minus"]
  },
  MOBILE_HOME: {
    path: "mobile-home.svg",
    tags: ["mobile home", "property"]
  },
  MOTOR_VEHICLE: {
    path: "motor-vehicle.svg",
    tags: ["motor vehicle", "vehicle", "property"]
  },
  MY_PROJECTS: {
    path: "myprojects.svg",
    tags: ["projects", "members navigation"]
  },
  NO_MULTICOLOR: {
    path: "no-multicolor.svg",
    tags: ["no", "x"]
  },
  NO_RED: {
    path: "no-red.svg",
    tags: ["no", "x"]
  },
  NO_RED_TWO: {
    path: "no-red-2.svg",
    tags: ["no", "x"]
  },
  ODOMETER_REFRESH: {
    path: "odometer-refresh.svg",
    tags: ["odometer", "refresh"]
  },
  ODOMETER_TOOLS: {
    path: "odometer-tools.svg",
    tags: ["odometer", "tools"]
  },
  ODOMETER_X: {
    path: "odometer-x.svg",
    tags: ["odometer", "x"]
  },
  OFFICE: {
    path: "office.svg",
    tags: ["office"]
  },
  ONE_QUARTER_REFRESH: {
    path: "onequarter-refresh.svg",
    tags: ["one", "quarter", "refresh"]
  },
  OTHER_PAYMENT: {
    path: "other-payment.svg",
    tags: ["payment", "other", "document"]
  },
  PEN_FILLED_GREEN: {
    path: "pen-filled-green.svg",
    tags: ["green", "pen", "status"]
  },
  PEN_FILLED_RED: {
    path: "pen-filled-red.svg",
    tags: ["red", "pen", "status"]
  },
  PEN_FILLED_YELLOW: {
    path: "pen-filled-yellow.svg",
    tags: ["yellow", "pen", "status"]
  },
  PENCIL: {
    path: "pencil.png",
    tags: ["pencil"]
  },
  PENCIL_LINE: {
    path: "pencil-line.svg",
    tags: ["pencil", "line", "edit"]
  },
  PENCIL_SQUARE: {
    path: "pencil-square.svg",
    tags: ["pencil", "square", "edit"]
  },
  PENCIL_SQUARE_BLUE: {
    path: "pencil-square-blue.svg",
    tags: ["pencil", "square", "edit", "blue"]
  },
  PENCIL_STARS: {
    path: "pencil-stars.svg",
    tags: ["pencil", "stars"]
  },
  PEOPLE_GROUP: {
    path: "people-groupof2.svg",
    tags: ["people", "group"]
  },
  PEOPLE_GROUP_TWO_FILLED_GREEN: {
    path: "people-group2-filled-green.svg",
    tags: ["people", "group", "green", "status"]
  },
  PEOPLE_GROUP_BLOCKED: {
    path: "people-groupof2-blocked.svg",
    tags: ["people", "group", "blocked"]
  },
  PEOPLE_GROUP_CHECKMARK: {
    path: "people-groupof2-checkmark.svg",
    tags: ["people", "group", "checkmark"]
  },
  PEOPLE_GROUP_CIRCLE: {
    path: "people-groupof2-circle.svg",
    tags: ["people", "group", "circle"]
  },
  PEOPLE_GROUP_CIRCLE_TWO: {
    path: "people-groupof2-circle-2.svg",
    tags: ["people", "group", "circle"]
  },
  PEOPLE_GROUP_CIRCLE_THREE: {
    path: "people-groupof2-circle-3.svg",
    tags: ["people", "group", "circle"]
  },
  PEOPLE_GROUP_EQUAL: {
    path: "people-groupof2-equal.svg",
    tags: ["people", "group", "equal"]
  },
  PEOPLE_GROUP_HALF: {
    path: "people-groupof2-half.svg",
    tags: ["people", "group", "half"]
  },
  PEOPLE_GROUP_PERCENT: {
    path: "people-groupof2-percent.svg",
    tags: ["people", "group", "percent"]
  },
  PEOPLE_LARGE_GROUP: {
    path: "people-groupof3.svg",
    tags: ["people", "group"]
  },
  PEOPLE_LARGE_GROUP_CHECKMARK: {
    path: "people-groupof3-checkmark.svg",
    tags: ["people", "group", "checkmark"]
  },
  PERCENT: {
    path: "percent.svg",
    tags: ["percent"]
  },
  PERSON_BLUE_ONE: {
    path: "person-blue-1.svg",
    tags: ["person"]
  },
  PERSON_BLUE_TWO: {
    path: "person-blue-2.svg",
    tags: ["person"]
  },
  PERSON_BLUE_CIRCLE: {
    path: "person-circle-blue.svg",
    tags: ["person", "circle"]
  },
  PERSON_BLUE_GREEN_CIRCLE: {
    path: "person-circle-blue-green.svg",
    tags: ["person", "circle"]
  },
  PERSON_BLUE_ORANGE_CIRCLE: {
    path: "person-circle-blue-orange.svg",
    tags: ["person", "circle"]
  },
  PERSON_BLUE_TEAL_CIRCLE: {
    path: "person-circle-blue-teal.svg",
    tags: ["person", "circle"]
  },
  PERSON_CHECK_FILLED_GREEN: {
    path: "person-check-filled-green.svg",
    tags: ["person", "check", "green", "status"]
  },
  PERSON_CLIPBOARD: {
    path: "person-clipboard.svg",
    tags: ["person", "clipboard"]
  },
  PERSON_CLIPBOARD_TEN: {
    path: "person-clipboard-number10.svg",
    tags: ["person", "clipboard"]
  },
  PERSON_DOCUMENT_MEDICAL: {
    path: "person-document-medicalcross.svg",
    tags: ["person", "document", "medical"]
  },
  PERSON_DOLLAR: {
    path: "person-dollar.svg",
    tags: ["person", "dollar"]
  },
  PERSON_EXCLAMATION: {
    path: "person-exclamation.svg",
    tags: ["person", "exclamation"]
  },
  PERSON_GREEN: {
    path: "person_green.png",
    tags: ["person"]
  },
  PERSON_GREEN_SVG: {
    path: "person-green.svg",
    tags: ["person"]
  },
  PERSON_HOUSE: {
    path: "person_house.png",
    tags: ["person", "house"]
  },
  PERSON_HOUSE_SVG: {
    path: "person-house.svg",
    tags: ["person", "house"]
  },
  PERSON_RASIED_HAND: {
    path: "person_raisedhand.svg",
    tags: ["person", "raised", "hand"]
  },
  PERSON_RASIED_HAND_BLOCKED: {
    path: "person_raisedhand-blocked.svg",
    tags: ["person", "raised", "hand", "blocked"]
  },
  PERSON_SLATE: {
    path: "person_slate.png",
    tags: ["person"]
  },
  PERSON_TEAL_YELLOW_CIRCLE: {
    path: "person-circle-teal-yellow.svg",
    tags: ["person", "circle"]
  },
  PERSON_THUMBS_UP: {
    path: "person_thumbs_up.png",
    tags: ["thumbs up", "person"]
  },
  PERSON_THUMBS_UP_SVG: {
    path: "person-thumbsup.svg",
    tags: ["thumbs up", "person"]
  },
  PERSON_YELLOW_BLUE_CIRCLE: {
    path: "person-circle-yellow-blue.svg",
    tags: ["person", "circle"]
  },
  PERSONAL_PROPERTY: {
    path: "personal-property.svg",
    tags: ["personal", "property", "couch"]
  },
  PET_CASH_BAG: {
    path: "pet_cash_bag.png",
    tags: ["pet", "cash", "bag"]
  },
  PET_CASH_BAG_SVG: {
    path: "bag-cat.svg",
    tags: ["pet", "cash", "bag"]
  },
  PET_CASH_WALLET: {
    path: "pet_cash_wallet.png",
    tags: ["pet", "cash", "wallet"]
  },
  PIECHART: {
    path: "piechart.svg",
    tags: ["piechart"]
  },
  PIECHART_DOLLAR: {
    path: "piechart-dollar.svg",
    tags: ["piechart", "dollar"]
  },
  PIECHART_DOLLAR_OUTLINE: {
    path: "piechart-dollar-outline.svg",
    tags: ["piechart", "dollar", "outline"]
  },
  PIECHART_PERCENT: {
    path: "piechart-percent.svg",
    tags: ["piechart", "percent"]
  },
  PIGGYBANK_WHITE: {
    path: "piggybank_white.png",
    tags: ["white", "piggybank"]
  },
  PLUS: {
    path: "plus.svg",
    tags: ["plus", "add"]
  },
  PRINTER: {
    path: "printer.svg",
    tags: ["printer"]
  },
  PRINTER_DOCUMENT_LOCK_CIRCLE: {
    path: "printer-document-lock-circle.svg",
    tags: ["print", "document", "lock", "circle"]
  },
  PRINTER_OUTLINE: {
    path: "printer-outline.svg",
    tags: ["printer", "outline"]
  },
  QUESTION_ACTIVE: {
    path: "question-active.svg",
    tags: ["question", "header icon", "members navigation"]
  },
  QUESTION_DEFAULT: {
    path: "question-default.svg",
    tags: ["question", "header icon", "members navigation"]
  },
  QUESTION_MARK_CIRCLE: {
    path: "question-mark-circle.svg",
    tags: ["question mark", "help"]
  },
  RENAME_GREY: {
    path: "rename-grey.svg",
    tags: ["rename", "grey", "status"]
  },
  RESTAURANT: {
    path: "restaurant.svg",
    tags: ["restaurant"]
  },
  RETAIL_STORE: {
    path: "retail-store.svg",
    tags: ["retail", "store"]
  },
  RIBBON: {
    path: "ribbon.svg",
    tags: ["ribbon"]
  },
  RIGHT_ARROWS: {
    path: "right-arrows.svg",
    tags: ["arrows", "right", "members navigation"]
  },
  RIGHT_ARROWS_IN_CIRCLE: {
    path: "right-arrows-in-circle.svg",
    tags: ["arrows", "right", "arrows in circle", "members navigation"]
  },
  ROOM: {
    path: "room.svg",
    tags: ["room", "property"]
  },
  ROOM_TWO: {
    path: "room-2.svg",
    tags: ["room", "property"]
  },
  SALES: {
    path: "sales.svg",
    tags: ["sales", "dollar", "category", "members navigation"]
  },
  SCALE: {
    path: "scale.png",
    tags: ["scale"]
  },
  SCREWDRIVER_PENCIL: {
    path: "screwdriver-pencil.svg",
    tags: ["screwdriver", "pencil"]
  },
  SEARCH_MAGNIFYING: {
    path: "search-magnifying.svg",
    tags: ["magnifying", "search", "glass"]
  },
  SIGNATURE_PENCIL: {
    path: "signature_pencil.png",
    tags: ["signature", "pencil"]
  },
  SIGNING: {
    path: "signing.svg",
    tags: ["signing"]
  },
  SPECIFY_DATE: {
    path: "specify-date.png",
    tags: ["date", "specific"]
  },
  SPECIFY_DATE_SVG: {
    path: "specify-date.svg",
    tags: ["date", "specific"]
  },
  STACK_ARROW_DOWN: {
    path: "stack-arrow-down.svg",
    tags: ["down", "arrow", "stack", "download"]
  },
  STAR: {
    path: "star.svg",
    tags: ["star", "upgrade", "members navigation"]
  },
  STAR_CHECK_FILLED_GREEN: {
    path: "star-check-filled-green.svg",
    tags: ["star", "check", "filled", "green", "status"]
  },
  THUMBS_DOWN_DOLLAR: {
    path: "thumbsdown-dollar.svg",
    tags: ["thumbs", "down", "dollar"]
  },
  TOWNHOUSE: {
    path: "townhouse.svg",
    tags: ["townhouse", "property"]
  },
  TRAILER: {
    path: "trailer.svg",
    tags: ["trailer", "hitch", "camper"]
  },
  TRAILER_YELLOW: {
    path: "trailer-yellow.svg",
    tags: ["trailer", "hitch", "camper"]
  },
  TRASHCAN: {
    path: "trashcan.svg",
    tags: ["trashcan", "delete", "remove"]
  },
  TWO_PEOPLE: {
    path: "two_people.png",
    tags: ["two people"]
  },
  TWO_PEOPLE_SPLIT_DOCUMENT: {
    path: "two-people-split-document.svg",
    tags: ["separation", "half document", "two people half document"]
  },
  US: {
    path: "US.png",
    tags: ["us", "usa", "united states"]
  },
  US_AK: {
    path: "USAK.png",
    tags: ["alaska", "ak", "usa"]
  },
  US_AK_SVG: {
    path: "us-alaska.svg",
    tags: ["alaska", "ak", "usa"]
  },
  US_AL: {
    path: "USAL.png",
    tags: ["alabama", "al", "usa"]
  },
  US_AL_SVG: {
    path: "us-alabama.svg",
    tags: ["alabama", "al", "usa"]
  },
  US_AR: {
    path: "USAR.png",
    tags: ["arkansas", "ar", "usa"]
  },
  US_AR_SCG: {
    path: "us-arkansas.svg",
    tags: ["arkansas", "ar", "usa"]
  },
  US_AZ: {
    path: "USAZ.png",
    tags: ["arizona", "az", "usa"]
  },
  US_AZ_SVG: {
    path: "us-arizona.svg",
    tags: ["arizona", "az", "usa"]
  },
  US_CA: {
    path: "USCA.png",
    tags: ["california", "ca", "usa"]
  },
  US_CA_SVG: {
    path: "us-california.svg",
    tags: ["california", "ca", "usa"]
  },
  US_CO: {
    path: "USCO.png",
    tags: ["colorado", "co", "usa"]
  },
  US_CO_SVG: {
    path: "us-colorado.svg",
    tags: ["colorado", "co", "usa"]
  },
  US_CT: {
    path: "USCT.png",
    tags: ["connecticut", "ct", "usa"]
  },
  US_CT_SVG: {
    path: "us-connecticut.svg",
    tags: ["connecticut", "ct", "usa"]
  },
  US_DC: {
    path: "US.png",
    tags: ["district of columbia", "dc", "usa"]
  },
  US_DC_SVG: {
    path: "us-columbia.svg",
    tags: ["district of columbia", "dc", "usa"]
  },
  US_DE: {
    path: "USDE.png",
    tags: ["delaware", "de", "usa"]
  },
  US_DE_SVG: {
    path: "us-delaware.svg",
    tags: ["delaware", "de", "usa"]
  },
  US_FL: {
    path: "USFL.png",
    tags: ["florida", "fl", "usa"]
  },
  US_FL_SVG: {
    path: "us-florida",
    tags: ["florida", "fl", "usa"]
  },
  US_GA: {
    path: "USGA.png",
    tags: ["georgia", "ga", "usa"]
  },
  US_GA_SVG: {
    path: "us-georgia",
    tags: ["georgia", "ga", "usa"]
  },
  US_GU: {
    path: "US.png",
    tags: ["guam", "gu", "usa"]
  },
  US_HI: {
    path: "USHI.png",
    tags: ["hawaii", "hi", "usa"]
  },
  US_HI_SVG: {
    path: "us-hawaii.svg",
    tags: ["hawaii", "hi", "usa"]
  },
  US_IA: {
    path: "USIA.png",
    tags: ["iowa", "ia", "usa"]
  },
  US_IA_SVG: {
    path: "us-iowa.svg",
    tags: ["iowa", "ia", "usa"]
  },
  US_ID: {
    path: "USID.png",
    tags: ["idaho", "id", "usa"]
  },
  US_ID_SVG: {
    path: "us-idaho.svg",
    tags: ["idaho", "id", "usa"]
  },
  US_IL: {
    path: "USIL.png",
    tags: ["illinois", "il", "usa"]
  },
  US_IL_SVG: {
    path: "us-illinois.svg",
    tags: ["illinois", "il", "usa"]
  },
  US_IN: {
    path: "USIN.png",
    tags: ["indiana", "in", "usa"]
  },
  US_IN_SVG: {
    path: "us-indiana.svg",
    tags: ["indiana", "in", "usa"]
  },
  US_KS: {
    path: "USKS.png",
    tags: ["kansas", "ks", "usa"]
  },
  US_KS_SVG: {
    path: "us-kansas.svg",
    tags: ["kansas", "ks", "usa"]
  },
  US_KY: {
    path: "USKY.png",
    tags: ["kentucky", "ky", "usa"]
  },
  US_KY_SVG: {
    path: "us-kentucky.svg",
    tags: ["kentucky", "ky", "usa"]
  },
  US_LA: {
    path: "USLA.png",
    tags: ["louisiana", "la", "usa"]
  },
  US_LA_SVG: {
    path: "us-louisiana.svg",
    tags: ["louisiana", "la", "usa"]
  },
  US_MA: {
    path: "USMA.png",
    tags: ["massachusetts", "ma", "usa"]
  },
  US_MA_SVG: {
    path: "us-massachusetts.svg",
    tags: ["massachusetts", "ma", "usa"]
  },
  US_MD: {
    path: "USMD.png",
    tags: ["maryland", "md", "usa"]
  },
  US_MD_SVG: {
    path: "us-maryland.svg",
    tags: ["maryland", "md", "usa"]
  },
  US_ME: {
    path: "USME.png",
    tags: ["maine", "me", "usa"]
  },
  US_ME_SVG: {
    path: "us-maine.svg",
    tags: ["maine", "me", "usa"]
  },
  US_MI: {
    path: "USMI.png",
    tags: ["michigan", "mi", "usa"]
  },
  US_MI_SVG: {
    path: "us-michigan.svg",
    tags: ["michigan", "mi", "usa"]
  },
  US_MN: {
    path: "USMN.png",
    tags: ["minnesota", "mn", "usa"]
  },
  US_MN_SVG: {
    path: "us-minnesota.svg",
    tags: ["minnesota", "mn", "usa"]
  },
  US_MO: {
    path: "USMO.png",
    tags: ["missouri", "mo", "usa"]
  },
  US_MO_SVG: {
    path: "us-missouri.svg",
    tags: ["missouri", "mo", "usa"]
  },
  US_MS: {
    path: "USMS.png",
    tags: ["mississippi", "ms", "usa"]
  },
  US_MS_SVG: {
    path: "us-mississippi.svg",
    tags: ["mississippi", "ms", "usa"]
  },
  US_MT: {
    path: "USMT.png",
    tags: ["montana", "mt", "usa"]
  },
  US_MT_SVG: {
    path: "us-montana.svg",
    tags: ["montana", "mt", "usa"]
  },
  US_NC: {
    path: "USNC.png",
    tags: ["north carolina", "nc", "usa"]
  },
  US_NC_SVG: {
    path: "us-northcarolina.svg",
    tags: ["north carolina", "nc", "usa"]
  },
  US_ND: {
    path: "USND.png",
    tags: ["north dakota", "nd", "usa"]
  },
  US_ND_SVG: {
    path: "us-northdakota.svg",
    tags: ["north dakota", "nd", "usa"]
  },
  US_NE: {
    path: "USNE.png",
    tags: ["nebraska", "ne", "usa"]
  },
  US_NE_SVG: {
    path: "us-nebraska.svg",
    tags: ["nebraska", "ne", "usa"]
  },
  US_NH: {
    path: "USNH.png",
    tags: ["new hampshire", "nh", "usa"]
  },
  US_NH_SVG: {
    path: "us-newhampshire.svg",
    tags: ["new hampshire", "nh", "usa"]
  },
  US_NJ: {
    path: "USNJ.png",
    tags: ["new jersey", "nj", "usa"]
  },
  US_NJ_SVG: {
    path: "us-newjersey.svg",
    tags: ["new jersey", "nj", "usa"]
  },
  US_NM: {
    path: "USNM.png",
    tags: ["new mexico", "nm", "usa"]
  },
  US_NM_SVG: {
    path: "us-newmexico.svg",
    tags: ["new mexico", "nm", "usa"]
  },
  US_NV: {
    path: "USNV.png",
    tags: ["nevada", "nv", "usa"]
  },
  US_NV_SVG: {
    path: "us-nevada.svg",
    tags: ["nevada", "nv", "usa"]
  },
  US_NY: {
    path: "USNY.png",
    tags: ["new york", "ny", "usa"]
  },
  US_NY_SVG: {
    path: "us-newyork",
    tags: ["new york", "ny", "usa"]
  },
  US_OH: {
    path: "USOH.png",
    tags: ["ohio", "oh", "usa"]
  },
  US_OH_SVG: {
    path: "us-ohio.svg",
    tags: ["ohio", "oh", "usa"]
  },
  US_OK: {
    path: "USOK.png",
    tags: ["oklahoma", "ok", "usa"]
  },
  US_OK_SVG: {
    path: "us-oklahoma.svg",
    tags: ["oklahoma", "ok", "usa"]
  },
  US_OR: {
    path: "USOR.png",
    tags: ["oregon", "or", "usa"]
  },
  US_OR_SVG: {
    path: "us-oregon.svg",
    tags: ["oregon", "or", "usa"]
  },
  US_PA: {
    path: "USPA.png",
    tags: ["pennsylvania", "pa", "usa"]
  },
  US_PA_SVG: {
    path: "us-pennsylvania.svg",
    tags: ["pennsylvania", "pa", "usa"]
  },
  US_PR: {
    path: "US.png",
    tags: ["puerto rico", "pr", "usa"]
  },
  US_RI: {
    path: "USRI.png",
    tags: ["rhode island", "ri", "usa"]
  },
  US_RI_SVG: {
    path: "us-rhodeisland.svg",
    tags: ["rhode island", "ri", "usa"]
  },
  US_SC: {
    path: "USSC.png",
    tags: ["south carolina", "sc", "usa"]
  },
  US_SC_SVG: {
    path: "us-southcarolina.svg",
    tags: ["south carolina", "sc", "usa"]
  },
  US_SD: {
    path: "USSD.png",
    tags: ["south dakota", "sd", "usa"]
  },
  US_SD_SVG: {
    path: "us-southdakota.svg",
    tags: ["south dakota", "sd", "usa"]
  },
  US_TN: {
    path: "USTN.png",
    tags: ["tennessee", "tn", "usa"]
  },
  US_TN_SVG: {
    path: "us-tennessee.svg",
    tags: ["tennessee", "tn", "usa"]
  },
  US_TX: {
    path: "USTX.png",
    tags: ["texas", "tx", "usa"]
  },
  US_TX_SVG: {
    path: "us-texas.svg",
    tags: ["texas", "tx", "usa"]
  },
  US_UT: {
    path: "USUT.png",
    tags: ["utah", "ut", "usa"]
  },
  US_UT_SVG: {
    path: "us-utah.svg",
    tags: ["utah", "ut", "usa"]
  },
  US_VA: {
    path: "USVA.png",
    tags: ["virginia", "va", "usa"]
  },
  US_VA_SVG: {
    path: "us-virginia.svg",
    tags: ["virginia", "va", "usa"]
  },
  US_VI: {
    path: "US.png",
    tags: ["virgin islands", "vi", "usa"]
  },
  US_VT: {
    path: "USVT.png",
    tags: ["vermont", "vt", "usa"]
  },
  US_VT_SVG: {
    path: "us-vermont.svg",
    tags: ["vermont", "vt", "usa"]
  },
  US_WA: {
    path: "USWA.png",
    tags: ["washington", "wa", "usa"]
  },
  US_WA_SVG: {
    path: "us-washington.svg",
    tags: ["washington", "wa", "usa"]
  },
  US_WI: {
    path: "USWI.png",
    tags: ["wisconson", "wi", "usa"]
  },
  US_WI_SVG: {
    path: "us-wisconson.svg",
    tags: ["wisconson", "wi", "usa"]
  },
  US_WV: {
    path: "USWV.png",
    tags: ["west virginia", "wv", "usa"]
  },
  US_WV_SVG: {
    path: "us-westvirginia.svg",
    tags: ["west virginia", "wv", "usa"]
  },
  US_WY: {
    path: "USWY.png",
    tags: ["wyoming", "wy", "usa"]
  },
  US_WY_SVG: {
    path: "us-wyoming.svg",
    tags: ["wyoming", "wy", "usa"]
  },
  USER_ACCOUNT_CIRCLE: {
    path: "user-account-circle.svg",
    tags: ["user-account", "user"]
  },
  USER_ACTIVE: {
    path: "user-active.svg",
    tags: ["user", "header-icon", "members navigation"]
  },
  USER_DEFAULT: {
    path: "user-default.svg",
    tags: ["user", "header-icon", "members navigation"]
  },
  WAREHOUSE: {
    path: "warehouse.svg",
    tags: ["warehouse"]
  },
  WARNING: {
    path: "warning.svg",
    tags: ["warning", "warning icon"]
  },
  WHEELBARROW: {
    path: "wheelbarrow.svg",
    tags: ["wheelbarrow"]
  },
  X: {
    path: "close_black_24dp.svg",
    tags: ["close", "x", "dialog"]
  }
}), g = "\\images\\icons\\", r = Object.entries(e).reduce(
  (a, [t, s]) => ({ ...a, [t]: g + s.path }),
  {}
);
export {
  r as ICONS,
  e as ICONS_DEFS,
  g as IMAGE_PATH
};
//# sourceMappingURL=icon-library.js.map
